export default __webpack_public_path__ + "static/media/desc_gris.f6fc8bec.svg";